module.exports = __webpack_public_path__ + "static/media/s-Spiral.a9025fff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/s-Spiral.png
// module id = 183
// module chunks = 0